export default {
  dynamics: '{{change}} par rapport à la semaine précédente',
};
